"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_icomoon_1 = __importDefault(require("react-icomoon"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const iconSet = require("./selection.json");
const Icon = (_a) => {
    var { icon } = _a, props = __rest(_a, ["icon"]);
    return react_1.default.createElement(StyledIcoMoon, Object.assign({ icon: icon, className: "icon", iconSet: iconSet }, props));
};
const StyledIcoMoon = (0, styled_components_1.default)(react_icomoon_1.default) `
  ${base_ui_components_atoms__atoms_1.common};
  color: ${({ theme, color = "secondary" }) => { var _a; return (_a = theme.color[color]) !== null && _a !== void 0 ? _a : color; }};
  min-width: ${({ width }) => width};
`;
exports.default = Icon;
//# sourceMappingURL=index.js.map